/**
 * Komal OS - Cash Flow Service
 * Thin wrappers around /api/cashflow/* (see app/routes/cashflow_routes.py).
 */

import api from './api';

// Forecast & project summary (computed live, nothing to create/update)
export const getForecast = (params = {}) => api.get('/cashflow/forecast', { params });
export const getProjectsSummary = (params = {}) => api.get('/cashflow/projects-summary', { params });
export const EXPORT_FORECAST_URL = '/cashflow/export/forecast';
export const exportForecastCsv = (params = {}) => api.get('/cashflow/export/forecast', { params, responseType: 'blob' });

// Receivables (Projects)
export const getReceivables = (params = {}) => api.get('/cashflow/receivables', { params });
export const createReceivable = (data) => api.post('/cashflow/receivables', data);
export const updateReceivable = (id, data) => api.put(`/cashflow/receivables/${id}`, data);
export const deleteReceivable = (id) => api.delete(`/cashflow/receivables/${id}`);
export const markReceivableReceived = (id, data = {}) => api.put(`/cashflow/receivables/${id}/mark-received`, data);
export const cancelReceivable = (id) => api.put(`/cashflow/receivables/${id}/cancel`);

// Material requirements (Purchase raises, Projects/CEO approves)
export const getMaterials = (params = {}) => api.get('/cashflow/materials', { params });
export const createMaterial = (data) => api.post('/cashflow/materials', data);
export const updateMaterial = (id, data) => api.put(`/cashflow/materials/${id}`, data);
export const deleteMaterial = (id) => api.delete(`/cashflow/materials/${id}`);
export const approveMaterial = (id) => api.put(`/cashflow/materials/${id}/approve`);
export const rejectMaterial = (id, rejection_reason) => api.put(`/cashflow/materials/${id}/reject`, { rejection_reason });
export const markMaterialOrdered = (id) => api.put(`/cashflow/materials/${id}/mark-ordered`);
export const markMaterialReceived = (id) => api.put(`/cashflow/materials/${id}/mark-received`);
export const markMaterialPaid = (id) => api.put(`/cashflow/materials/${id}/mark-paid`);
export const getMaterialsImportTemplate = () => api.get('/cashflow/materials/import-template', { responseType: 'blob' });
export const importMaterials = (file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/cashflow/materials/import', form, { headers: { 'Content-Type': undefined } });
};

// Site payment requirements (Site)
export const getSiteRequirements = (params = {}) => api.get('/cashflow/site-requirements', { params });
export const createSiteRequirement = (data) => api.post('/cashflow/site-requirements', data);
export const updateSiteRequirement = (id, data) => api.put(`/cashflow/site-requirements/${id}`, data);
export const deleteSiteRequirement = (id) => api.delete(`/cashflow/site-requirements/${id}`);

// Recurring expenses (Accounts)
export const getRecurringExpenses = (params = {}) => api.get('/cashflow/recurring-expenses', { params });
export const createRecurringExpense = (data) => api.post('/cashflow/recurring-expenses', data);
export const updateRecurringExpense = (id, data) => api.put(`/cashflow/recurring-expenses/${id}`, data);
export const deleteRecurringExpense = (id) => api.delete(`/cashflow/recurring-expenses/${id}`);

// Post-dated cheques & payment dues (Accounts)
export const getPostDatedItems = (params = {}) => api.get('/cashflow/post-dated-items', { params });
export const createPostDatedItem = (data) => api.post('/cashflow/post-dated-items', data);
export const updatePostDatedItem = (id, data) => api.put(`/cashflow/post-dated-items/${id}`, data);
export const deletePostDatedItem = (id) => api.delete(`/cashflow/post-dated-items/${id}`);
export const markPostDatedItemCleared = (id) => api.put(`/cashflow/post-dated-items/${id}/mark-cleared`);

// Cash position snapshots (Accounts)
export const getLatestCashPosition = () => api.get('/cashflow/cash-position');
export const getCashPositionHistory = () => api.get('/cashflow/cash-position/history');
export const createCashPosition = (data) => api.post('/cashflow/cash-position', data);
